var irreducible = require('./irreducible');

module.exports = irreducible('RegExp', function (x) { return x instanceof RegExp; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/RegExp.js
 ** module id = 34
 ** module chunks = 0
 **/